import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { employeeBussiness } from "api/bussiness/employee/employee-bussiness";
import { numberFormatAsString } from "commons/ultilities";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { getLabelOfBranch } from "pages/stella-inspection-note/share";
import { useCallback, useEffect, useState } from "react";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
import { XAvatar } from "share-components/x-avatar/x-avatar";

export const EmployeeBasicTable = observer(() => {
  const {
    employeeManagement: { employeeDetail },
  } = useStores();
  const [imageSource, setImageSource] = useState<File | null>(null);
  const fetchAvatar = useCallback(async () => {
    if (employeeDetail?.avatar?.name) {
      const res = await employeeBussiness.getAvatar(
        employeeDetail?.avatar?.name
      );
      setImageSource(res);
    }
  }, [employeeDetail?.avatar?.name]);

  useEffect(() => {
    fetchAvatar();
  }, [fetchAvatar]);
  return (
    <XTablePagination hidePagination>
      <TableHead>
        <TableRow>
          <TableCell align="center">Mã NV</TableCell>
          <TableCell align="center">Họ & Tên</TableCell>
          <TableCell align="center">Hình ảnh</TableCell>
          <TableCell align="center">H/S Năm</TableCell>
          <TableCell align="center">Bộ Phận/ Khâu SX</TableCell>
          <TableCell align="center">Chức Vụ</TableCell>
          <TableCell align="center">Cấp Bậc</TableCell>
          <TableCell align="center">Trình Độ</TableCell>
          <TableCell align="center">Giới Tính</TableCell>
          <TableCell align="center">Tuổi</TableCell>
          <TableCell align="center">Chi Nhánh</TableCell>
          <TableCell align="center">Ghi chú</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell align="center">{employeeDetail?.code || ""}</TableCell>
          <TableCell align="center">{employeeDetail?.fullName || ""}</TableCell>
          <TableCell align="center" width={100}>
            <XAvatar
              style={{
                width: "100px",
                height: "100px",
                backgroundColor: "unset",
              }}
              src={imageSource || ""}
              alt="Avatar"
              readOnly
            />
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.hsYear &&
              numberFormatAsString(employeeDetail?.hsYear?.toString(), {
                decimalScale: 2,
                emtyWhenZero: false,
              })}
          </TableCell>

          <TableCell align="center">
            {employeeDetail?.departmentType?.name || ""}
          </TableCell>
          <TableCell align="center">{employeeDetail?.position || ""}</TableCell>
          <TableCell align="center">{employeeDetail?.level || ""}</TableCell>
          <TableCell align="center">
            {employeeDetail?.qualification || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.genderModel?.value || ""}
          </TableCell>
          <TableCell align="center">{employeeDetail?.age || ""}</TableCell>
          <TableCell align="center">
            {employeeDetail?.branch
              ? getLabelOfBranch(employeeDetail?.branch)
              : ""}
          </TableCell>
          <TableCell align="center">{employeeDetail?.note || ""}</TableCell>
        </TableRow>
      </TableBody>
    </XTablePagination>
  );
});
